module.exports = __webpack_public_path__ + "static/img/StimulusModeGray.f94fd9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StimulusModeGray.png
// module id = dJQi
// module chunks = 1